module.exports = __webpack_public_path__ + "media/landmarks.c185d2f0.mp4";